import React from 'react';
import { Grid } from '@material-ui/core';
import SpecificComponent from './SpecificComponent';
import LocalStorage from '../providers/LocalStorage';
import avatar from '../Pics/avatar.jpg'
import Ws from '../providers/Ws';
import Utils from '../providers/Utils';

export default class ButtonsModules  extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
           objUser: {}
 
}
    }

     componentDidMount(){
        this.getDetaliiUser()
    }

    getDetaliiUser = async()=>{
        let ws = new Ws()

        let ls = new LocalStorage()

        if (this.props.scop === 'pontaj'){
            // console.log('this.props.objUser :', this.props.objUser);
            this.setState({objUser: this.props.objUser})
        }else{
            let angajati = await ws.customSelect('select * from angajati',{
                p1:1
            })
    
            // console.log('angajati :', angajati);
    
            let user =await ws.customSelect(`select u.id, a.nume, a.poza , u.email, u.telefon, a.adresa from angajati a 
                                            left outer join useri u on (a.id_user = u.id) where u.id = @p1 `,{
                           p1:this.props.idUser ? this.props.idUser : ls.GetUserData().InfoUser.IdUser                     
                                            })
    
                                            // console.log('user :', user);
             if(user.Succes){
                 this.setState({objUser:user.Content[0]},()=>{
                    //  console.log('this.staet.objUser :', this.state.objUser);
                 })
             } 
        }

                      
    }

    goToPage=(page)=>{

        this.props.history.push(`/${page}`)
    }

    legenda = ()=>{
        if(this.props.scop === 'Management Proiecte'){
            return <div style={{ marginTop: 10 }}>


            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(122, 209, 58)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.proiecte.status.finalizata}</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'red' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.proiecte.status.blocat}</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(58, 180, 209)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.proiecte.status.inviitor}</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(251, 141, 0)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.proiecte.status.inlucru}</span>
            </div>
        </div>
        }else if(this.props.scop ==='Financiar'){
            return <div style={{ marginTop: 10 }}>


            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(122, 209, 58)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.financiarContabil.foarteBun}</span>
            </div>
            
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(226, 241, 9)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.financiarContabil.bun}</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(251, 141, 0)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.financiarContabil.slab}</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'red' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.financiarContabil.rau}</span>
            </div>
        </div>
        }else if(this.props.scop ==='Chestionare'){
            return  <div style={{ marginTop: 10 }}>


            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(122, 209, 58)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.proiecte.status.finalizata}</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'red' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.proiecte.status.blocat}</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(58, 180, 209)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.proiecte.status.inviitor}</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'rgb(251, 141, 0)' }} className='pm-task-legend'></div>
                <span className='pm-title'>{this.dictionary.proiecte.status.inlucru}</span>
            </div>
        </div>
                   
        }else if(this.props.scop === 'soldFurnizor'){
            return  <div style={{ marginTop: 10 }}>


            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: '#904807' }} className='pm-task-legend'></div>
                <span className='pm-title'>Furnizor</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: '#0f83dc' }} className='pm-task-legend'></div>
                <span className='pm-title'>Client</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'red' }} className='pm-task-legend'></div>
                <span className='pm-title'>Bilet de ordin furnizor</span>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div style={{ backgroundColor: 'green' }} className='pm-task-legend'></div>
                <span className='pm-title'>Bilet de ordin client</span>
            </div>
           
        </div>
        }
        // else if(this.props.scop === 'pontaj'){
        //     return  <div style={{ marginTop: 10 }}>


        //     <div style={{ textAlign: 'left' }}>
        //         <div style={{ backgroundColor: 'rgb(117, 234, 117)' }} className='pm-task-legend'></div>
        //         <span className='pm-title'>Prezenti peste 80%</span>
        //     </div>
        //     <div style={{ textAlign: 'left' }}>
        //         <div style={{ backgroundColor: 'orange' }} className='pm-task-legend'></div>
        //         <span className='pm-title'>Prezenti intre 50% - 80%</span>
        //     </div>
        //     <div style={{ textAlign: 'left' }}>
        //         <div style={{ backgroundColor: 'red' }} className='pm-task-legend'></div>
        //         <span className='pm-title'>Prezenti sub 50%</span>
        //     </div>
       
           
        // </div>
        // }
    }

    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }

       uploadPoza =async (id, idAngajat) =>{
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);
  
        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);
  
  
            let uploadImage = await ws.uploadimage('Upload/PozaAngajat' ,saveFile, idAngajat);

           

            // console.log('uploadImage :', uploadImage);
            if(uploadImage.Succes){
             this.getDetaliiUser()
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);
  
        }
       }


       goToUser=()=>{
        let lS = new LocalStorage()

        //  let user = lS.GetUserData()

        //  console.log('user :', user);

        
             this.props.history.push(`/infouser/${this.state.objUser.id}`)
         
     }
  
     render() { 
       return (

        <Grid style={{ width: '95%', margin: '20px auto' }} container>
            <Grid item style={{ borderRight: '1px dashed gray', textAlign: 'left' }} xs={12} sm={12} md={2} lg={2} xl={2}>

{this.state.objUser && 
    <div 
                   onClick={this.goToUser}
                   id='pm-user-avatar' style={{
                width: 100,
                height: 100,
                backgroundImage: `url(${this.state.objUser.poza ? (new Ws().adresaMedia + '/Angajati/' + this.state.objUser.poza )  : avatar })`,
                backgroundRepeat: 'no-reapeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                display: 'inline-block'
            }}>

            <input type='file' id={`fileavatar`}
                                                              style={{display:'none'}}
                                                              accept='image/*'
                                                              onChange={()=>{this.uploadPoza(`fileavatar`, this.state.objUser.id)}} />  

            </div>
}
            


            <div className='pm-user-info'>

                <h3 style={{ marginBottom: 0, textAlign: 'left', marginTop: 0 }} className='pm-title'>{this.state.objUser.nume}</h3>
                <h5 style={{ marginTop: 5, textAlign: 'left', marginBottom:0 }} className='pm-title'>{this.state.objUser.adresa}</h5>
                <h5 style={{ marginTop: 5, textAlign: 'left' }} className='pm-title'>{this.state.objUser.telefon}</h5>
            </div>


            <h4 style={{ marginBottom: 0, textAlign: 'left', marginTop: 0 }} className='pm-title'>Email: {this.state.objUser.email}</h4>

            {/* {this.legenda()} */}


        </Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
        <Grid container style={{justifyContent:'center'}}>
                                <Grid item xs={12} sm={6} md={4} lg={1} xl={1}>

                        <div onClick={()=>{this.goToPage('projects')}} style={{ backgroundColor: '#d07070b5' }} className='pm-top-menu-cards' >

                            <i className='material-icons pm-top-menu-buttons-icons'>assessment</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.managementProiecte}</span>
                        </div>


                        </Grid>
                        <Grid  item xs={12} sm={6} md={4} lg={1} xl={1}>

                        <div  style={{ backgroundColor: '#5c5ce2b8' }} className='pm-top-menu-cards'>
                             <i className='material-icons pm-top-menu-buttons-icons'>event_note</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.chestionare}</span>
                        </div>


                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={1} xl={1}>

                        <div onClick={()=>{this.goToPage('financiarcontabil')}} style={{ backgroundColor: '#abab2fa8' }} className='pm-top-menu-cards'>
                        <i className='material-icons pm-top-menu-buttons-icons'>money</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.financiar}</span>
                        </div>


                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={1} xl={1}>

                        <div onClick={()=>{new LocalStorage().GetUserData().InfoUser.IsAdmin !== 1 ? this.goToPage(`pontaj/${this.state.objUser.id}`) : this.goToPage(`pontaje`)}} style={{ backgroundColor: '#9a1eb7a3' }} className='pm-top-menu-cards'>
                        <i className='material-icons pm-top-menu-buttons-icons'>timer</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.pontaj}</span>
                        </div>


                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={1} xl={1}>

                        <div onClick={()=>{this.goToPage('evaluareactivitati')}} style={{ backgroundColor: '#1bce2ac4' }} className='pm-top-menu-cards'>
                        <i className='material-icons pm-top-menu-buttons-icons'>assignment_ind</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.evalActivitatiiAngajati}</span>
                        </div>


                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={1} xl={1}>

                        <div style={{ backgroundColor: '#00c2ffcc' }} className='pm-top-menu-cards'>
                        <i className='material-icons pm-top-menu-buttons-icons'>people_outline</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.evalDeColegi}</span>
                        </div>


                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={1} xl={1}>

                        <div style={{ backgroundColor: '#ff8400d4' }} className='pm-top-menu-cards'>
                        <i className='material-icons pm-top-menu-buttons-icons'>people</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.evalClienti}</span>
                        </div>


                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={1} xl={1}>

                        <div onClick={()=>{this.goToPage('organigrama')}} style={{ backgroundColor: 'rgba(239, 16, 96, 0.83)' }} className='pm-top-menu-cards'>
                        <i className='material-icons pm-top-menu-buttons-icons'>device_hub</i>
                            <span className='pm-home-card-text'>{this.dictionary.home.organigrama}</span>
                        </div>


                        </Grid>

        </Grid>
    </Grid>
      
        {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <div onClick={() => { this.goToPage('projects') }} className='pm-home-buttons' style={{ lineHeight: 'inherit', backgroundColor: '#9a30d6', borderBottomColor: '#986bc1' }}>
                <span style={{ display: 'block', marginTop: 44 }}>Management de proiecte</span>
            </div>


        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <div onClick={() => { this.goToPage('chestionare') }} className='pm-home-buttons'>
                <span >Chestionare</span>
            </div>


        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <div onClick={() => { this.goToPage('financiarcontabil') }} className='pm-home-buttons' style={{ backgroundColor: '#3dd818', borderBottomColor: '#288449' }}>
                <span >Financiar</span>
            </div>


        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <div className='pm-home-buttons' style={{ backgroundColor: '#6f8abfe0', borderBottomColor: '#2c6e88' }}>
                <span >Pontaj</span>
            </div>


        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <div className='pm-home-buttons' style={{ lineHeight: 'inherit', backgroundColor: '#ff81f3', borderBottomColor: '#da7474' }}>
                <span style={{ display: 'block', marginTop: 37 }}>Evaluarea activitatii angajati</span>
            </div>


        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <div className='pm-home-buttons' style={{ lineHeight: 'inherit', backgroundColor: '#e60844', borderBottomColor: '#bf2355' }}>
                <span style={{ display: 'block', marginTop: 42 }}>Evaluarea de catre colegi</span>
            </div>


        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <div style={{ lineHeight: 'inherit', backgroundColor: '#2e40ca', borderBottomColor: '#7f88ec' }} className='pm-home-buttons'>
                <span style={{ display: 'block', marginTop: 37 }}>Evaluarea din partea clientilor</span>
            </div>


        </Grid> */}
    </Grid>


        );
       }
}